export default __webpack_public_path__ + "static/media/Apple iPhone 12 Mini.4b31fecd.png";